import { composeClassNames, withDefault } from "@faedev/editor-utils";
import { CSSProperties, ReactNode } from "react";
import { sParagraph } from "src/styles/sParagraph.module.scss";
import { CSSFontWidth } from "src/types/CSSFontWidth";
import { CSSTextAlign } from "src/types/CSSTextAlign";
import { VariantSize } from "src/types/VariantSize";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  size?: VariantSize | null | undefined;
  children?: ReactNode;
  width?: CSSFontWidth | null | undefined;
  align?: CSSTextAlign | null | undefined;
};

function Paragraph({ style, className, size, children, width, align }: Props) {
  return (
    <div
      className={composeClassNames([
        sParagraph,
        withDefault(size, `nm`),
        withDefault(width, `regular`),
        withDefault(align, `left`),
        className,
        "paragraph",
      ])}
      style={style}
    >
      {children}
    </div>
  );
}

export default Paragraph;
